// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-src_app__shared_base_core_ts-src_app__shared_directives_var_directive_ts-src_app_ui_i-682732":"42fc6237f8b6cdb0","src_app_auth_auth_module_ts":"5699ba5a3d28b23a","src_app_modules_ugol-blueprints_ugol-blueprints_module_ts":"4d9fef40be0471a3"}[chunkId] + ".js";
};